import { render, staticRenderFns } from "./FileSetup.vue?vue&type=template&id=3a205a39"
import script from "./FileSetup.vue?vue&type=script&lang=js"
export * from "./FileSetup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports